module.exports = __webpack_public_path__ + "static/screenshot-6-a504a2febd871234774bc9fb4cee402a.png";